export const environment = {
  production: true,
  airlineLogoUrl: 'https://storage.googleapis.com/test-tcat-static-assets/images/airlinelogos/{}.png',
  baseUrl: 'https://api.demo.tcat.app',
  portalVersion: '1.1.0',
  api: {},
  cdn: {
    images: {
      baseUrl: ''
    }
  },
  mapApiKey: '',
  placeDetailWidgetEnabled: false
};
